export const NavbarTitles = [ 'khuôn sắt', 'khuôn nhựa', 'mặt hàng khác', 'thông tin']
export const NavbarTitle = [
    {
        t: ['hàng rào', 'đấu trụ', 'chậu cảnh', 'cửa sổ']
    },
    {
        t: ['hàng rào', 'đấu trụ', 'chậu cảnh', 'cửa sổ']
    },
    {
        t: ['khuôn bê tông', 'sắt ly']
    },
]